<template>
  <ul class="fz-18 text-white font-medium list-disc pl-10">
    <li v-for="item in items" :key="item">{{ item }}</li>
  </ul>
</template>

<script>
export default {
  name: "miniMarkedList",
  props:['items']
}
</script>

<style scoped>

</style>